@if (!isNavigated()) {
<app-loading-spinner spinnerType="primary" mode="fullscreen" />
} @else if (!showSidenavLayout()) {
<router-outlet></router-outlet>
} @else {
<app-toolbar></app-toolbar>
<app-sidenav></app-sidenav>
}
